 document.addEventListener("DOMContentLoaded", () => {
            const gallery = document.querySelector(".gallery");
            const galleryResize = document.querySelector(".gallery__resize");
            const before = document.querySelector("#before");
            const after = document.querySelector("#after");

            gallery.addEventListener("mousemove", (event) => {
                let x = event.offsetX;
                galleryResize.style.width = x + "px";
                galleryResize.classList.remove("tr");
            });

            before.onclick = () => {
                galleryResize.style.width = "100%";
                galleryResize.classList.add("tr");
            };

            after.onclick = () => {
                galleryResize.style.width = "0%";
                galleryResize.classList.add("tr");
            };

            const wrapper = document.querySelector(".wrapper");
            const baf = document.querySelector(".baf");
            const photoBefore = document.querySelector(".img-before");
            const photoAfter = document.querySelector(".img-after");
            const photoBeforeArray = [
                "https://cdn.shopify.com/s/files/1/0622/2777/5548/files/before-under-eyes-1.jpg",
                "https://cdn.shopify.com/s/files/1/0622/2777/5548/files/before-neck-1.jpg",
                "https://cdn.shopify.com/s/files/1/0622/2777/5548/files/before-vitac-1_8a5aa9a5-f79c-464c-8543-b2ddfce1b550.jpg",
            ];
            const photoAfterArray = [
                "https://cdn.shopify.com/s/files/1/0622/2777/5548/files/after-under-eyes-1.jpg",
                "https://cdn.shopify.com/s/files/1/0622/2777/5548/files/after-neck-1.jpg",
                "https://cdn.shopify.com/s/files/1/0622/2777/5548/files/after-vitac-1_bad6f920-fa68-4a41-9358-1ad9fadc6fd4.jpg",
            ];
            const photoNames = ["Under Eye Gel", "Neck Firming Cream", "Vitamin C Face Cream"];
            const photoNamesDesc = [
                "Under eye gel with scientifically-backed ingredients, our under eye gel is designed to reduce dark circles and puffiness while also hydrating and firming the delicate skin around eyes.",
                "Effective neck cream that works to firm and tighten the skin on your neck & décolletage with powerful anti-aging ingredients, helps reduce the appearance of wrinkles and saggy skin.",
                "Vitamin C moisturizer is a brightening and rejuvenating cream that helps fade dark spots and even out skin tone, providing deep hydration while targeting pigmentation & dullness.",
            ];
            const photoUrls = [
                 "https://alozera.com/products/under-eye-gel-cream",
                "https://alozera.com/products/neck-firming-cream",
                "https://alozera.com/products/vitamin-c-face-cream",
            ];

            const left = document.querySelector("#left");
            const right = document.querySelector("#right");
            const photoName = document.querySelector("#photo-name");
            const photoNameDesc = document.querySelector("#photo-name-desc");
            const photoUrl = document.querySelector("#photo-url");

            let count = 0;
            let countPhoto = 1;

            right.addEventListener("click", nextPhoto);
            left.addEventListener("click", prevPhoto);

            window.addEventListener("keydown", (e) => {
                let w = galleryResize.offsetWidth;

                if (e.keyCode === 39) {
                    nextPhoto();
                } else if (e.keyCode === 37) {
                    prevPhoto();
                } else if (e.keyCode === 38) {
                    galleryResize.classList.remove("tr");
                    w = w + 50;
                    getW(w);
                    if (w > gallery.offsetWidth) {
                        galleryResize.style.width = "100%";
                    }
                } else if (e.keyCode === 40) {
                    galleryResize.classList.remove("tr");
                    w = w - 50;
                    getW(w);
                }
            });

            // Touch event handling for resizing
            gallery.addEventListener("touchstart", (e) => {
                const touch = e.touches[0];
                let x = touch.clientX - gallery.getBoundingClientRect().left;
                galleryResize.style.width = x + "px";
                galleryResize.classList.remove("tr");
            });

            gallery.addEventListener("touchmove", (e) => {
                const touch = e.touches[0];
                let x = touch.clientX - gallery.getBoundingClientRect().left;
                if (x >= 0 && x <= gallery.offsetWidth) {
                    galleryResize.style.width = x + "px";
                }
                e.preventDefault();
            });

            gallery.addEventListener("touchend", () => {
                galleryResize.classList.add("tr");
            });

            const title = createSpanCount(countPhoto);
            wrapper.append(title);

            function nextPhoto() {
                count++;
                countPhoto++;
                if (count >= photoBeforeArray.length) {
                    count = 0;
                    countPhoto = 1;
                }
                updatePhoto();
            }

            function prevPhoto() {
                count--;
                countPhoto--;
                if (count < 0) {
                    count = photoBeforeArray.length - 1;
                    countPhoto = photoBeforeArray.length;
                }
                updatePhoto();
            }

            function updatePhoto() {
                photoBefore.src = photoBeforeArray[count];
                photoAfter.src = photoAfterArray[count];
                photoName.textContent = photoNames[count];
                photoNameDesc.textContent = photoNamesDesc[count];
                photoUrl.href = photoUrls[count];
                photoUrl.textContent = "Buy This Offer!";
                title.innerHTML = `${countPhoto} / ${photoBeforeArray.length}`;
                galleryResize.style.width = "50%";
                galleryResize.classList.add("tr");
            }

            function createSpanCount(n) {
                const title = document.createElement("h3");
                title.id = "photo-count";
                title.innerHTML = `${n} / ${photoBeforeArray.length}`;
                return title;
            }

            function getW(n) {
                galleryResize.style.width = n + "px";
                if (n > gallery.offsetWidth) return;
            }

            // Automatic rotation
            let autoRotate = setInterval(nextPhoto, 5000); // Change the photo every 5 seconds

            // Stop rotation on mouseover and touchstart
            function stopRotation() {
                clearInterval(autoRotate);
            }

            // Restart rotation on mouseout and touchend
            function startRotation() {
                autoRotate = setInterval(nextPhoto, 8000);
            }

            gallery.addEventListener("mouseover", stopRotation);
            gallery.addEventListener("mouseout", startRotation);
            wrapper.addEventListener("touchstart", stopRotation);
            wrapper.addEventListener("touchend", startRotation);
            baf.addEventListener("touchstart", stopRotation);
            baf.addEventListener("touchend", startRotation);
        });